import { TRootState } from "store";
import { ICasesState } from "./cases.types";

export const getCasesSelector = (state: TRootState): ICasesState => state.cases;
